import axios from "axios";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import swal from "sweetalert";

const Employment = () => {
  const [inputList, setInputList] = useState([
    { position: "", company: "", salary: "" },
  ]);

  const [salary, setSalary] = useState("");
  const [position, setPosition] = useState("");
  const [company, setCompany] = useState("");
  const [allOccupation, setAllOccupation] = useState([]);
  const [infoBuffer, setInfoBuffer] = useState(false);
  const [data, setData] = useState(true);

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    const list = [...inputList];
    list[index][name] = value;
    setInputList(list);
  };

  const handleAddClick = () => {
    setInputList([...inputList, { position: "", company: "", salary: "" }]);
  };

  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  useEffect(() => {
    axios.get(`/api/user_info`).then((res) => {
      setData(false);
      if (res.status === 200) {
        // setSalary(res.data?.users?.user_info?.salery_range);
        setPosition(res.data?.users?.user_info?.occupation);
        setCompany(res.data?.users?.user_info?.company);
      }
    });
  }, []);

  useEffect(() => {
    axios.get(`/api/user/occupation`).then((res) => {
      setData(false);
      if (res.status === 200) {
        setAllOccupation(res.data.occupation);
      }
    });
  }, []);
  const employmentHandle = (e) => {
    e.preventDefault();
    setInfoBuffer(true);
    const formData = new FormData();

    // formData.append("salery_range", salary);
    formData.append("position", position);
    formData.append("company", company);

    //add member to group
    axios.post(`/api/user/employment/store`, formData).then((res) => {
      setInfoBuffer(false);
      if (res.data.status === 200) {
        if(res.data.message == "Employment Updated Successfully"){
          swal("Operation Successful", "Employment information updated successfully!", "success");
        }else {
          swal("Operation Successful", res.data.message, "success");
        }
      }
    });
  };

  return (
    <>
      <form onSubmit={employmentHandle}>
        <div className="row col-md-12 mx-md-2 justify-content-center">
          <h5 className="text-light text-left">Employment Information</h5>
          <div className="under-line-x mb-3 mt-1"></div>
        </div>
        <center>
          <div className="row col-sm-12 col-md-12 col-lg-10 justify-content-center">
            <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">
              <div>Occupation</div>
              <div>&nbsp;:</div>
            </div>

            <div className="col-sm-12 col-md-8 mb-3">
              <select
                className="form-control form-control-sm account-input-style"
                onChange={(e) => setPosition(e.target.value)}
                value={position}
              >
                <option value="">Select Your Occupation</option>
                {allOccupation &&
                  allOccupation.map((item) => (
                    <option
                      value={item.title}
                      selected={item.title === position}
                    >
                      {" "}
                      {item.title}{" "}
                    </option>
                  ))}
              </select>
            </div>

            <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between" style={{textAlign:"left"}}>
              <div>Govt / Company</div>
              <div>&nbsp;:</div>
            </div>
            <div className="col-sm-12 col-md-8 mb-3">
              <input
                onChange={(e) => setCompany(e.target.value)}
                value={company}
                placeholder="Enter your company"
                className="from-control w-100 custom-con-input form-control-sm "
              />
            </div>

            {/*<div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">*/}
            {/*  <div>Salary Range</div>*/}
            {/*  <div>&nbsp;:</div>*/}
            {/*</div>*/}
            {/*<div className="col-sm-12 col-md-8 mb-3">*/}
            {/*  <input*/}
            {/*    onChange={(e) => setSalary(e.target.value)}*/}
            {/*    value={salary}*/}
            {/*    className="from-control w-100 custom-con-input form-control-sm "*/}
            {/*    placeholder="Enter your Salary"*/}
            {/*  />*/}
            {/*</div>*/}
          </div>

          <div className="d-flex col-md-4 col-lg-4 mb-3 text-light justify-content-md-between">
            <div></div>
            <div></div>
          </div>
          <div className="col-sm-12 col-md-8 mb-3 justify-content-center my-3 ">
            <div className="col-md-4">
              {data ? (
                <>
                  <button className="form-control form-control-sm account-input-style">
                    <i className="fas fa-spinner fa-pulse"></i>
                  </button>
                </>
              ) : (
                <button className="btn BTnInfo w-100 fw-bold" type="submit">
                  {infoBuffer ? (
                    <>
                      <i className="fas fa-spinner fa-pulse"></i>&nbsp;
                    </>
                  ) : (
                    <></>
                  )}
                  Save
                </button>
              )}
            </div>
          </div>
        </center>
      </form>
    </>
  );
};

export default Employment;
